<script setup lang="ts">
import { useForm } from "@inertiajs/vue3"
import AuthShell from "./components/AuthShell.vue"

const props = defineProps<{
  email?: string
  errors?: Record<string, string[]>
}>()

const form = useForm({
  email: props.email ?? "",
  password: "",
  remember_me: false,
})

const fieldError = (field: string) => props.errors?.[field]?.[0]
</script>

<template>
  <AuthShell title="Entrar" subtitle="Acesse sua conta para continuar.">
    <form class="space-y-4" @submit.prevent="form.post('/users/sign_in')">
      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="email">E-mail</label>
        <input id="email" v-model="form.email" type="email" required class="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200" />
        <p v-if="fieldError('email')" class="mt-1 text-sm text-rose-600">{{ fieldError('email') }}</p>
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="password">Senha</label>
        <input id="password" v-model="form.password" type="password" required class="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200" />
        <p v-if="fieldError('password')" class="mt-1 text-sm text-rose-600">{{ fieldError('password') }}</p>
      </div>

      <label class="flex items-center gap-2 text-sm text-slate-700">
        <input v-model="form.remember_me" type="checkbox" class="h-4 w-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500" />
        Lembrar de mim
      </label>

      <p v-if="fieldError('base')" class="text-sm text-rose-600">{{ fieldError('base') }}</p>

      <button type="submit" :disabled="form.processing" class="w-full rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60">
        Entrar
      </button>
    </form>
  </AuthShell>
</template>
